import { PayOutFrequency } from "../../implementation-specialist/models/payOutFreq";
import { Address } from "./address";
import { Column, emptyColumn } from "./column";
import { ExternalAccount, PaynowExternalAccount } from "./external-account";
import { Workflow } from "./client"
import { PrimaryContact } from "./primary-contact";
import { CustomConfig } from "./client-details";

export interface ClientFacility { // implementation and client onboarding
  userFacilityScopeId: number;
  facilityId: number;
  clientId?: number;
  customDocTokenId?: string;
  facilityName: string;
  patientPmtFreq: string;
  payOutFreq: PayOutFrequency;
  payOutDay: number;
  addressId: number;
  address?: Address; // for frontend only
  phoneNum?: string;
  facilityType?: string;
  isRuleSetupComplete?: boolean;
  outpatientEnabled?: boolean;
  taxId: string;
  taxIdLast4: string;
  rcInNetworkPfrHigh?: number;
  rcInNetworkPfrLow?: number;
  rcOutOfNetworkPfrHigh?: number;
  rcOutOfNetworkPfrLow?: number;
  vboPfrThreshold?: number;
  vboTimeThreshold?: number;
  websiteUrl?: string;
  externalAccount: ExternalAccount;
  paynowExternalAccount?: PaynowExternalAccount;
  primaryContact?: PrimaryContact;
  SSN: string;
  DOB: string;
  bankName: string;
  routingNumber: string;
  accountNumber: string;
  connectedAccount: string;
  documentation: string;
  status?: string; // frontend only
  column?: Column[]; // frontend only
  workflow?: Workflow;
  customConfigs?: CustomConfig[];
  workflowStatusDt?: string;
}


export const emptyClientFacility: ClientFacility = {
  userFacilityScopeId: 0,
  facilityId: 0,
  facilityName: "",
  patientPmtFreq: "",
  payOutFreq: "daily",
  payOutDay: -1,
  addressId: -1,
  facilityType: "",
  taxId: "",
  taxIdLast4: "",
  externalAccount: {
    externalAccountId: "",
    externalStatus: ""
  },
  DOB: "",
  SSN: "",
  bankName: "",
  routingNumber: "",
  accountNumber: "",
  connectedAccount: "",
  documentation: "accepted",
  status: "",
  column: [emptyColumn]
};
